var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20.54 16" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_user"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_information" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icon_user" },
            React.createElement("path", { id: "item_user1", className: styles["cls-1"] || "cls-1", d: "M6.47 4.72c0 2.61 1.69 5.3 3.78 5.3S14 7.33 14 4.72 12.34 0 10.25 0 6.47 2.12 6.47 4.72z" }),
            React.createElement("path", { id: "item_user2", className: styles["cls-1"] || "cls-1", d: "M10.27 6.1h2.28s-.27 2.31.52 3.4A3.28 3.28 0 0 0 15.3 11c1.24.38 1.56.76 3.38 1.49a2.91 2.91 0 0 1 1.61 1.7 3.24 3.24 0 0 1 .19 1.81H.06a3.14 3.14 0 0 1 .19-1.83 2.89 2.89 0 0 1 1.6-1.7C3.67 11.74 4 11.36 5.24 11a3.28 3.28 0 0 0 2.23-1.5C8.26 8.41 8 6.1 8 6.1z" })
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/iconStroke/images/user.svg
// module id = 1649
// module chunks = 0